import React from 'react';
import { Button } from '@/components/ui/button';

interface QuickSuggestionsProps {
  onSelect: (suggestion: string) => void;
}

export function QuickSuggestions({ onSelect }: QuickSuggestionsProps) {
  const suggestions = [
    "Hvor mange tokens har jeg igjen?",
    "Hvordan lager jeg en ny sak?",
    "Hvordan fungerer dokumentgenerering?",
    "Kontakt support"
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {suggestions.map((suggestion) => (
        <Button
          key={suggestion}
          variant="outline"
          size="sm"
          onClick={() => onSelect(suggestion)}
          className="text-sm"
        >
          {suggestion}
        </Button>
      ))}
    </div>
  );
}